import { ViewModel,View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { PhoneInputViewModel } from "src/common/utilities/phoneInput/phoneInput-viewModel";
import { AllDistrictsWithChildrenViewModel } from "src/EnterpriseAdministration/districtManipulation/districtSelector";
import { CitySelectorViewModel } from "src/Financial/cityManipulation/cityManipulation-viewModel";
import { ProvinceSelectorViewModel } from "src/Financial/provinceManipulation/provinceManipulation-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { CustomerCreationRequest } from "../customerCreationRequestManipulation/customerCreationRequestManipulation-viewModel";
import  { ConfirmCustomerRequestView } from "./confirmCustomerRequest-view"
import { CustomerAttributeLicenseSelectorViewModel, CustomerAttributeProfessionSelectorViewModel, CustomerAttributeWorkingAreaSelectorViewModel } from "../customerAttribute/customerAttributesSelector-viewModel";

export class ConfirmCustomerRequestViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.citySelector = new CitySelectorViewModel(this);
        this.customerAttributeLicense = new CustomerAttributeLicenseSelectorViewModel(this);
        this.customerAttributeProfession = new CustomerAttributeProfessionSelectorViewModel(this);
        this.customerAttributeWorkingArea = new CustomerAttributeWorkingAreaSelectorViewModel(this);
        this.districtSelector = new AllDistrictsWithChildrenViewModel(this);
        this.provinceSelector = new ProvinceSelectorViewModel(this);
        this.provinceSelector.onSelectionChanged = x=> {
            this.citySelector.provinceId = x?.id
        };
        this.phoneInput = new PhoneInputViewModel(this);
    }

    closePopup(resultCode: string = null) {
    }

    GetDefaultView(): View <ViewModel> {
        return new ConfirmCustomerRequestView();
    }
    public getTypeId(): string {
        return "VM-001521AD-7102-4B00-BF5C-C52E9A44F940"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set lastname(v: string) { this._lastname = v; } public get lastname(): string { return this._lastname;} private _lastname: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set nationalCode(v: string) { this._nationalCode = v; } public get nationalCode(): string { return this._nationalCode;} private _nationalCode: string;
    public set address(v: string) { this._address = v; } public get address(): string { return this._address;} private _address: string;
    public set districtSelector(v: AllDistrictsWithChildrenViewModel) { this._districtSelector = v; } public get districtSelector(): AllDistrictsWithChildrenViewModel { return this._districtSelector;} private _districtSelector: AllDistrictsWithChildrenViewModel;
    public set districtId(v: string) { this._districtId = v; } public get districtId(): string { return this._districtId;} private _districtId: string;
    public set districtName(v: string) { this._districtName = v; } public get districtName(): string { return this._districtName;} private _districtName: string;

    public set provinceSelector(v: ProvinceSelectorViewModel) { this._provinceSelectorViewModel = v; } public get provinceSelector(): ProvinceSelectorViewModel { return this._provinceSelectorViewModel;} private _provinceSelectorViewModel: ProvinceSelectorViewModel;
    public set provinceId(v: string) { this._provinceId = v; } public get provinceId(): string { return this._provinceId;} private _provinceId: string;
    public set provinceName(v: string) { this._provinceName = v; } public get provinceName(): string { return this._provinceName;} private _provinceName: string;
    public set customerAttributeLicense(v: CustomerAttributeLicenseSelectorViewModel) { this._customerAttributeLicenseViewModel = v; } public get customerAttributeLicense(): CustomerAttributeLicenseSelectorViewModel { return this._customerAttributeLicenseViewModel;} private _customerAttributeLicenseViewModel: CustomerAttributeLicenseSelectorViewModel;
    public set customerAttributeProfession(v: CustomerAttributeProfessionSelectorViewModel) { this._customerAttributeProfessionViewModel = v; } public get customerAttributeProfession(): CustomerAttributeProfessionSelectorViewModel { return this._customerAttributeProfessionViewModel;} private _customerAttributeProfessionViewModel: CustomerAttributeProfessionSelectorViewModel;
    public set customerAttributeWorkingArea(v: CustomerAttributeWorkingAreaSelectorViewModel) { this._customerAttributeWorkingAreaViewModel = v; } public get customerAttributeWorkingArea(): CustomerAttributeWorkingAreaSelectorViewModel { return this._customerAttributeWorkingAreaViewModel;} private _customerAttributeWorkingAreaViewModel: CustomerAttributeWorkingAreaSelectorViewModel;
    
    public set citySelector(v: CitySelectorViewModel) { this._citySelector = v; } public get citySelector(): CitySelectorViewModel { return this._citySelector;} private _citySelector: CitySelectorViewModel;
    public set cityId(v: string) { this._cityId = v; } public get cityId(): string { return this._cityId;} private _cityId: string;
    public set cityName(v: string) { this._cityName = v; } public get cityName(): string { return this._cityName;} private _cityName: string;
    
    public set phoneInput(v: PhoneInputViewModel) { this._phoneInput = v; } public get phoneInput(): PhoneInputViewModel { return this._phoneInput;} private _phoneInput: PhoneInputViewModel;
    
    async cloneTo(customerEdit:CustomerCreationRequest){
        this.id = customerEdit.id;
        this.name = customerEdit.name;
        this.lastname = customerEdit.lastName;
        this.comment = customerEdit.comment;
        this.nationalCode = customerEdit.nationalCode;
        this.address = customerEdit.address;
        this.setDistrict(customerEdit.districtId);
        this.setProvince(customerEdit.provinceId, customerEdit.provinceName);
        this.setCity(customerEdit.cityId, customerEdit.cityName);
        this.phoneInput.addCellPhone(...customerEdit.cellphones);
        this.phoneInput.addPhone(...customerEdit.phones);
        await Promise.all([
            this.customerAttributeLicense.refresh(),
            this.customerAttributeProfession.refresh(),
            this.customerAttributeWorkingArea.refresh()
        ]);
        this.setCustomerAttribute(customerEdit.customerAttributes.map(q => q.id));
    }
    async save () {
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت درخواست');
                return;
            }
            this.isLoading = true;
            let phones = this.phoneInput.getPhones();
            let cellPhones = this.phoneInput.getCellPhones();
            let result = await ServerConnection.callServer('/Complex/CrmServices/ConfirmCustomerCreationRequest',{
                CustomerCreationRequestId: this.id,
                Name: this.name,
                LastName: this.lastname,
                NationalCode: this.nationalCode,
                Comment: this.comment,
                Address: this.address,
                DistrictId: this.getDistrictId(),
                Province: this.getProvinceId(),
                City: this.getCityId(),
                Phones: phones.map((q,i)=>{
                    return {
                        Index : i+1,
                        CountryCode : q.countryCode,
                        CityCode: q.cityCode,
                        Number: q.number
                    }
                }),
                AttributeValues: [
                    this.getCustomerAttributeLicense(),
                    this.getCustomerAttributeProfession(),
                    this.getCustomerAttributeWorkingArea()
                ],
                CellPhones: cellPhones.map((q,i)=>{
                    return {
                        Index : i+1,
                        CountryCode : q.countryCode,
                        Number: q.number
                    }
                })
            });
            if(result.IsSuccessful==false){
                if (result.Faults[0].Parameters.FaultId === "F48EB25F-25DD-426C-B4F2-180F33075369")
                    throw "این شماره تماس قبلا تعریف شده است";
                throw "خطا در انجام عملیات";
            }
            await this.messageBoxConfirmSuccess('درخواست ایجاد مشتری جدید با موفقیت انجام شد.','عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning(ex,'خطا');
        } finally {
            this.isLoading = false;
        }
    }                                                                    
 
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push(' نام مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.lastname)){
            result.push(' نام خانوادگی مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.getCityId())){
            result.push(' شهر مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.getProvinceId())){
            result.push(' استان مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.getDistrictId())){
            result.push(' شعبه مشخص نشده است.')
        }
        if(this.phoneInput.getCellPhones().length <= 0){
            result.push('حداقل یک شماره همراه باید ثبت شود.')
        }
        return result;
    }    
    
    getCustomerAttributeWorkingArea() {
        return {
            Id: this.customerAttributeWorkingArea.selectedItem?.id,
            Name: this.customerAttributeWorkingArea.selectedItem?.title
        };
    }

    getCustomerAttributeLicense() {
        return {
            Id: this.customerAttributeLicense.selectedItem?.id,
            Name: this.customerAttributeLicense.selectedItem?.title
        };
    }

    getCustomerAttributeProfession(): object {
        return {
            Id: this.customerAttributeProfession.selectedItem?.id,
            Name: this.customerAttributeProfession.selectedItem?.title
        };
    }

    getDistrictId() {
        return this.districtSelector.selectedItem?.id;
    }

    setDistrict(id: string) {
        this.districtSelector.selectById(id);
    }
    
    setProvince(id: string, name: string) {
        this.provinceSelector.selectById(id);
    }
    
    setCustomerAttribute(values) {
        values.forEach(id => {
            if(this.customerAttributeProfession.items.filter(q => q.id == id).length > 0)
                this.customerAttributeProfession.selectById(this.customerAttributeProfession.items.find(q => q.id == id)?.id);
            if(this.customerAttributeWorkingArea.items.filter(q => q.id == id).length > 0)
                this.customerAttributeWorkingArea.selectById(id);
            if(this.customerAttributeLicense.items.filter(q => q.id == id).length > 0)
                this.customerAttributeLicense.selectById(id);
        });
    }
    
    getProvinceId() {
        return this.provinceSelector.selectedItem?.id;
    }
    
    setCity(id: string, name: string) {
        this.citySelector.selectById(id);
    }
    
    getCityId() {
        return this.citySelector.selectedItem?.id;
    }
    
}